import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface DeleteSourceConfirmationModalProps {
    isOpen: boolean;
    count?: number;
    deleteInProgress?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function DeleteSourceConfirmationModal({
    isOpen,
    count = 1,
    deleteInProgress,
    onConfirm,
    onCancel,
}: DeleteSourceConfirmationModalProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    const isBulk = count > 1;

    return (
        <Modal
            isOpen={isOpen}
            title={t(
                isBulk
                    ? 'deleteSelectedConfirmTitle'
                    : 'deleteSourceConfirmTitle',
                { count },
            )}
            description={t(
                isBulk
                    ? 'deleteSelectedConfirmDescription'
                    : 'deleteSourceConfirmDescription',
                { count },
            )}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={deleteInProgress}
            submitText={t(isBulk ? 'actions.delete' : 'actions.deleteSource')}
            maxWidth="max-w-[471px]"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
        />
    );
}
